<template>
  <div :ref="`media-photo-${downloadId}`" class="mc-vehicle-media__media-photo-item-wrapper">
    <b-spinner v-if="loadingGeneratePicture" small />
    <img v-else :src="src" />
    <span class="mc-vehicle-media__media-photo-label-camera">
      {{ $t('trackVideo.camera') }} {{ cameraNumber }}
    </span>
    <div class="mc-vehicle-media__media-photo-action">
      <span class="mc-vehicle-media__media-photo-action-download" @click="handleClickDownload">
        <i class="mc-icon icon-outline_download" />
        <span>{{ $t('global.action.download') }}</span>
      </span>
      <span class="mc-vehicle-media__media-photo-action-fullscreen" @click="handleClickFullscreen">
        <i v-show="!fullscreen" class="mc-fa icon-fill_fullscreen"></i>
        <i v-show="fullscreen" class="mc-fa icon-fill_exit-fullscreen"></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cameraNumber: {
      type: Number,
      required: true,
    },
    src: {
      type: String,
      required: true,
    },
    downloadId: {
      type: Number,
      required: true,
    },
    mediaFilename: {
      type: String,
      required: true,
    },
    loadingGeneratePicture: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      fullscreen: false,
    }
  },
  methods: {
    handleClickDownload() {
      if (this.src) {
        const link = document.createElement('a')
        link.href = this.src
        link.setAttribute('download', this.mediaFilename)
        link.click()
        link.remove()
      }
    },
    async handleClickFullscreen() {
      this.fullscreen = !this.fullscreen
      await this.$nextTick()
      const figureDom = this.$refs[`media-photo-${this.downloadId}`]
      figureDom.classList.toggle('mc-vehicle-media__media-fullscreen')
      if (this.fullscreen) {
        var elem = document.documentElement

        if (elem.requestFullscreen) {
          elem.requestFullscreen()
        } else if (elem.webkitRequestFullscreen) {
          /* Safari */
          elem.webkitRequestFullscreen()
        } else if (elem.msRequestFullscreen) {
          /* IE11 */
          elem.msRequestFullscreen()
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitExitFullscreen) {
          /* Safari */
          document.webkitExitFullscreen()
        } else if (document.msExitFullscreen) {
          /* IE11 */
          document.msExitFullscreen()
        }
      }
    },
  },
}
</script>
